import { render } from "./TicketHistory.vue?vue&type=template&id=f6ed3be2&scoped=true"
import script from "./TicketHistory.vue?vue&type=script&lang=js"
export * from "./TicketHistory.vue?vue&type=script&lang=js"

import "./TicketHistory.vue?vue&type=style&index=0&id=f6ed3be2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ed3be2"]])

export default __exports__